import { render, staticRenderFns } from "./SupplierCompApproval.vue?vue&type=template&id=aefbe5d8&scoped=true&"
import script from "./SupplierCompApproval.vue?vue&type=script&lang=js&"
export * from "./SupplierCompApproval.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCompApproval.vue?vue&type=style&index=0&id=aefbe5d8&prod&scoped=true&lang=css&"
import style1 from "./SupplierCompApproval.vue?vue&type=style&index=1&id=aefbe5d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefbe5d8",
  null
  
)

export default component.exports